import * as React from "react";
import { isPendoEnabled } from "./env";
import { initializeAnonymous } from "./telemetry";

export default function InitializeTrackingManager() {
  React.useEffect(() => {
    if (isPendoEnabled) {
      initializeAnonymous();
    }
  }, []);

  return null;
}
